module.exports = __webpack_public_path__ + "img/settings.30ef4bd2.svg";